import React, { ReactNode } from 'react';
import { useAuth } from '../hooks/useAuth';
import { PermissionLevel } from '../types';

interface ProtectedElementProps {
  // Legacy: Sistema de roles (mantener para backward compatibility)
  requiredRoles?: string[];

  // Nuevo sistema dinámico: Nombre del recurso (ej: "Home", "Settings", "Assistants")
  // El nombre será resuelto dinámicamente a UUID desde la base de datos
  requiredResource?: string;

  // Nivel de permiso requerido (VIEW o EDIT)
  requiredLevel?: PermissionLevel;

  // Props existentes
  children: ReactNode;
  fallback?: ReactNode;
}

export function ProtectedElement({
  requiredRoles = [],
  requiredResource,
  requiredLevel = PermissionLevel.VIEW,
  children,
  fallback = null
}: ProtectedElementProps) {
  const { user, hasPermission } = useAuth();

  // MODO 1: Sistema de roles (LEGACY - mantener para backward compatibility)
  if (requiredRoles.length > 0) {
    if (!user?.role || !requiredRoles.includes(user.role)) {
      return <>{fallback}</>;
    }
    return <>{children}</>;
  }

  // MODO 2: Sistema dinámico - requiredResource (nombre del recurso)
  // El nombre será resuelto dinámicamente a UUID usando el cache de resourceService
  if (requiredResource) {
    const hasAccess = hasPermission(requiredResource, requiredLevel);

    if (!hasAccess) {
      return <>{fallback}</>;
    }
    return <>{children}</>;
  }

  // CASO DEFAULT: Sin restricciones
  return <>{children}</>;
} 